import React from "react";

export const Container = ({ children, className = "", ...props }) => {
    return (
        <div
            className={`mx-auto w-full max-w-7xl px-6 lg:px-10 ${className}`}
            {...props}
        >
            {children}
        </div>
    );
};

export default Container;
